import request from "../index";

// 获取首页信息
export function homePage(postdata){
  return request({
      method:"post",
      url:"/module/web/list",
      data:postdata
  })
}

// 搜索
export function searchFn(postdata){
  return request({
      header:{
        'Content-Type':'application/x-www-form-urlencoded'
      },
      method:"get",
      url:"/home/search?",
      data:postdata,
      type:true
  })
}


// 新增合作申请
export function addPartner(postdata){
  return request({
    method:"post",
    url:"/cooperateApplication/web/add",
    data:postdata
  })
}


// WEBPACK FOOTER //
// ./src/api/modules/home.js